<template>
  <div ref="containerRef" style="width: 100%; height: 100%"></div>
</template>

<script setup>
/*
 * 阿里在线文档，内部组件。使用方调用 AliOfficeWrapper.vue即可。
 */
import { onMounted, ref } from "vue";

const containerRef = ref(null);

onMounted(() => {
  init(containerRef.value);
});

const props = defineProps({
  getTokenFun: {
    type: Function,
    required: true
  },
  refreshTokenFun: {
    type: Function,
    required: true
  },
});

const emit = defineEmits(["ready"])

let ins

async function init(mount, timeout = 32 * 60 * 1000) {
  if(!mount){
    console.error("确保挂载节点元素存在。 一般在 onMounted 钩子中调用。")
  }
  // 获取 token
  let tokenInfo = await props.getTokenFun();

  ins = window.aliyun.config({
    mount,
    url: tokenInfo.WebofficeURL,
    refreshToken: () => {
      // timeout过期时刷新 token
      return props.refreshTokenFun(tokenInfo).then((data) => {
        // 保存供下次 refreshTokenFun 用
        Object.assign(tokenInfo, data);

        return {
          token: tokenInfo.AccessToken,
          timeout,
        };
      });
    },
  });

  ins.setToken({
    token: tokenInfo.AccessToken,
    timeout,
  });

  emit('ready')
}

// 全屏放映，仅支持PPT
async function pptFullPlay() {
  await ins.ready();
  const app = ins.Application;
  const SlideShowSettings = await app.ActivePresentation.SlideShowSettings;
  await SlideShowSettings.Run();   //切换到幻灯片全屏播放状态
}

defineExpose({
  pptFullPlay
})
</script>
